import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-tagline">
          Fast and secure cryptocurrency transactions, storage, and exchange
        </div>
        
        <div className="footer-security">
          <p>At QuantumSync, our top-tier security measures and transparent practices ensure that all your cryptocurrency transactions <strong>are safe and fraud-free.</strong></p>
        </div>
        
        <div className="footer-contact">
          <h3>Contact Our Team</h3>
          <p className="contact-email">info@quantumsync.tech</p>
          <p className="contact-address">QuantumSync s.r.o. C 388554<br />Cimburkova 916/8, Žižkov, 130 00 Praha 3, Czech Republic</p>
        </div>
        
        <div className="footer-bottom">
          <p>© Copyright 2026 QuantumSync s.r.o. C 388554 – Czech Republic. All rights reserved</p>
          
          <div className="footer-licensing">
            <a href="https://or.justice.cz/ias/ui/rejstrik-firma.vysledky?subjektId=1211260&typ=UPLNY" target="_blank" rel="noopener noreferrer">Licensing Information</a>
          </div>
          
          <div className="footer-links-bottom">
            <Link to="/kyc-aml-policy">AML Policy</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
            <Link to="/investment-risk-notice">Risk Disclaimer</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <Link to="/contact">Contact us</Link>
          </div>
        </div>
        
        <div className="footer-disclaimer">
          <p>Our services are not directed to, or intended for use by, residents or citizens of the United Kingdom or the United States of America. By using our services, you confirm that you are not located in, or a resident or citizen of, the United Kingdom or the United States of America.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
